export default "__VITE_ASSET__Fk$KSwUC__"